
















































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { BeraterService } from "@/services/berater-service";
import { User } from "@/models/user-model";
import { ErrorBag, Validator, FieldBag } from "vee-validate";
import router from "../../router";
import BtFormGroup from "../../components/BtFormGroup.vue";
import { BtChoserType } from "../../components/bt-choser/bt-choser-models";
import BtChoser from "../../components/bt-choser/BtChoser.vue";
import {
  GlobalHelper,
  confirmAction,
  confirmDeletion,
} from "@/helper/global-helper";
import EditPageBase from "@/views/Generic/EditPageBase.vue";
import { LookupModule, LookupStore } from "@/store/modules/lookup-store";
import {
  Berechtigung,
  EffektiveBerechtigung,
  lookup_Berechtigung,
} from "@/lib";
import UserNameDisplay from "@/components/UserNameDisplay.vue";
import BeraterGruppeApi from "@/Beratergruppen/api/BeraterGruppeAPI";

@Component({
  components: { BtFormGroup, BtChoser, UserNameDisplay },
})
export default class BeraterEdit extends EditPageBase {
  private maxProjektTeams = 2;

  private beraterService!: BeraterService;
  private beraterGruppenService!: BeraterGruppeApi;
  public BtChoserType = BtChoserType;
  public user: User = new User();
  public errors!: ErrorBag;
  public fields!: FieldBag;
  public lookupStore: LookupModule = LookupStore;
  private allgemeine_Berechtigungen: Record<string, true> = {};
  private kunden_Berechtigungen: Record<string, Record<string, true>> = {};

  public chosenProjektTeams: number[] = [];

  public $validator!: Validator;
  private loading: boolean = true;
  private sending: boolean = false;
  private isLoadingBeraterGruppen = false;

  async created() {
    this.beraterService = new BeraterService();
    this.beraterGruppenService = new BeraterGruppeApi();
  }

  async loadBeraterGrupperForId(id: number) {
    try {
      this.isLoadingBeraterGruppen = true;

      const matchingBeraterGruppen =
        await this.beraterGruppenService.GetBeraterGruppenForBeraterById(id);

      return matchingBeraterGruppen;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      this.isLoadingBeraterGruppen = false;
    }
  }

  @Watch("chosenProjektTeams")
  assertMaximumChoice(next: number[], prev: number[]) {
    if (next.length > this.maxProjektTeams) {
      GlobalHelper.NotifyError(
        `Mehr als ${this.maxProjektTeams} ${this.$t(
          "Administration.Projektteam"
        )} ausgewählt`
      );
      this.chosenProjektTeams = [...prev];
    }
  }

  async mounted() {
    const id: number = Number(
      this.$route.params.id ? this.$route.params.id : 0
    );
    this.$route.params.id;
    if (id != 0) {
      this.user = await this.beraterService.GetById(id);
      const matchingBeraterGruppenIds = (
        await this.loadBeraterGrupperForId(id)
      ).map(({ Id }) => Id);
      this.chosenProjektTeams = matchingBeraterGruppenIds;
    }

    this.allgemeine_Berechtigungen = {};
    this.kunden_Berechtigungen = {};

    if (this.opadmin && id != 0) {
      for (const src of this.user.EffektiveBerechtigungen) {
        const s = src as any;
        if (!s.kunde_id) {
          this.allgemeine_Berechtigungen[
            lookup_Berechtigung[s.uuid] || s.uuid
          ] = true;
        } else {
          if (!this.kunden_Berechtigungen[s.kunde_id as string]) {
            this.kunden_Berechtigungen[s.kunde_id as string] = {};
          }
          this.kunden_Berechtigungen[s.kunde_id as string][
            lookup_Berechtigung[s.uuid] || s.uuid
          ] = true;
        }
      }
    }

    this.loading = false;

    await this.$nextTick();
    this.enableWatch("user");
  }

  get opadmin(): boolean {
    return this.hat_Berechtigung("Zugriff_betriebliche_Administration");
  }

  async resendInvitation() {
    try {
      this.sending = true;
      await this.beraterService.ResendInvitation(this.user);
      GlobalHelper.NotifySuccess(this.$t("Berater.Einladung gesendet"));
      this.user = await this.beraterService.GetById(this.user.Id);
    } catch (e) {
      console.log(e);
    } finally {
      this.sending = false;
    }
  }

  async removeOTP() {
    confirmDeletion(
      this.$t("Benutzer.OTP deaktivieren"),
      this.$t("Benutzer.OTP deaktivieren-confirm"),
      this.$t("Benutzer.OTP deaktivieren"),
      this.$t("Abbrechen"),
      async () => {
        try {
          this.sending = true;
          await this.beraterService.RemoveOTP(this.user);
          GlobalHelper.NotifySuccess(this.$t("Benutzer.OTP deaktiviert"));
          this.user = await this.beraterService.GetById(this.user.Id);
        } catch (e) {
          console.log(e);
        } finally {
          this.sending = false;
        }
      },
      () => {}
    );
  }

  async checkSave(event: any) {
    event.preventDefault();
    await this.$validator.validateAll();
    if (this.errors.count() != 0) {
      GlobalHelper.NotifyError(
        this.$t("Allgemein.Pflichtfeld nicht ausgefüllt.").toString()
      );
    } else {
      let emailField = this.$validator.fields.items.find(
        (x) => x.name === "Berater.Email"
      );
      if (emailField) {
        if (this.user.Id != 0 && (emailField.flags as any).changed == true) {
          confirmAction(
            this.$t("Berater.E-Mail Adresse geändert"),
            this.$t("Berater.Nachfrage E-Mail Adresse geändert", {
              email: emailField.value,
            }),
            this.$t("Fortfahren"),
            this.$t("Abbrechen"),
            async () => {
              await this.save(event);
            },
            () => {
              return;
            }
          );
        } else {
          await this.save(event);
        }
      }
    }
  }

  async deleteItem() {
    confirmDeletion(
      this.$t("Berater.Berater löschen"),
      this.$t(
        "Berater.Wollen Sie den Berater wirklich unwiderruflich löschen?"
      ),
      this.$t("Berater.Berater löschen"),
      this.$t("Abbrechen"),
      async () => {
        await this.beraterService.Delete(this.user);
        this.$router.push({ name: "administration-beraterlist" });
      },
      () => {}
    );
  }

  async save(event: any) {
    try {
      this.disableWatch();
      this.sending = true;
      if (this.user.Id == 0) {
        this.user = await this.beraterService.Post(this.user);
      } else {
        this.user = await this.beraterService.Put(this.user);
      }
      await this.beraterGruppenService.UpdateBeraterInGruppen(
        this.user.Id,
        this.chosenProjektTeams
      );
      this.dirty = false;
      GlobalHelper.NotifySuccess();
      router.push("/administration/berater");
    } catch (e) {
      console.log(e);
    } finally {
      this.sending = false;
    }
  }

  get isAdminSelect(): any {
    return [
      { id: true, text: "Berater.Administrator" },
      { id: false, text: "Berater.Berater" },
    ];
  }

  @Watch("user.Rolle_ICS_Administrator")
  on_user1() {
    this.user.Rolle_ICS_Berater = !this.user.Rolle_ICS_Administrator;
  }
}
